import { render, staticRenderFns } from "./order-sender.vue?vue&type=template&id=862220aa&"
import script from "./order-sender.vue?vue&type=script&lang=js&"
export * from "./order-sender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports